















































































































































































import { Component, Prop, Mixins,Watch } from "vue-property-decorator";

import { summaryInfo } from "@/api/order";
import filterTime from "@/utils/filterTime";
// 请求
import axios from "axios";
import config from "@/config/default";
import loading from "@/mixins/loading";
import { selectOperation } from "@/api/operation";

@Component
export default class HelloWorld extends Mixins(loading) {
  @Prop() private fromDate!: string;
  @Prop() private toDate!: string;
  @Prop() private nickname!: string;
  @Prop() private phone!: string;
  @Prop() private receiverName!: string;
  @Prop() private receiverPhone!: string;
  @Prop() private orderId!: string;
  @Prop() private productName!: string;
  @Prop() private payType!: number;
  @Prop() private orderStatus!: number;
  @Prop() private shippingMethod!: string;

  shippingMethodArr = ["1","2"];

  payTypes: Array<any> = [
    {
      id: "",
      label: "全部",
    },
    {
      id: 0,
      label: "未支付",
    },
    {
      id: 1,
      label: "养生元",
    },
    {
      id: 2,
      label: "微信支付",
    },
    {
      id: 3,
      label: "赠送金额",
    },
    {
      id: 4,
      label: "养生元+微信",
    },
    {
      id: 5,
      label: "养生元+赠送金额",
    },
    {
      id: 6,
      label: "养生元+赠送金额+微信支付",
    },
    {
      id: 7,
      label: "微信支付+赠送金额",
    },
  ];

  // 构造器自有属性
  options: Array<any> = [
    {
      id: 20,
      label: "全部",
    },
    {
      id: 0,
      label: "待付款",
    },
    {
      id: 3,
      label: "待发货",
    },
    {
      id: 5,
      label: "已发货",
    },
    {
      id: 9,
      label: "已完成",
    },
    {
      id: 11,
      label: "已关闭",
    },
    {
      id: 12,
      label: "售后",
    },
  ];

operationSubCompanyId: number|null = null;
  operationServiceId: number|null = null;
  operationMemberId: number|null = null;
  subCompanyList: Array<any> = [];
  serviceList: Array<any> = [];
  memberList: Array<any> = [];

  getSubCompany(str:any){
    if(typeof str == 'object'){
      str = ''
    }
    selectOperation({
      roleType:2,
      roleName:str
    }).then((res: any) => {
      this.subCompanyList = res.data;
    });
  }

  getService(str:any){
    if(typeof str == 'object'){
      str = ''
    }
    selectOperation({
      parentId:this.operationSubCompanyId,
      roleType:3,
      roleName:str
    }).then((res: any) => {
      this.serviceList = res.data;
    });
  }

  getMember(str:any){
    if(typeof str == 'object'){
      str = ''
    }
    selectOperation({
      parentId:this.operationServiceId,
      roleType:4,
      roleName:str
    }).then((res: any) => {
      this.memberList = res.data;
    });
  }
  
  @Watch('operationSubCompanyId')
  toSubCompanyId(val:number) {
    this.$emit('input', val, 'subCompanyId')
  }
  @Watch('operationServiceId')
  toServiceId(val:number) {
    this.$emit('input', val, 'serviceId')
  }
  @Watch('operationMemberId')
  toOperationMemberId(val:number) {
    this.$emit('input', val, 'operationMemberId')
  }

  @Watch("shippingMethodArr")
  changeShipping() {
    let shippingMethodArr = this.shippingMethodArr;
    let shippingMethod = '';
    if(shippingMethodArr.length == 1){
      shippingMethod = shippingMethodArr.join();
    }
    this.$emit('input', shippingMethod, 'shippingMethod');
    this.shippingMethod = shippingMethod;
  }

  mounted() {
    this.getData();
  }

  // 获取数据
  getData() {
    let tempOrderStatus = <any>this.orderStatus;
    if (tempOrderStatus == 20) {
      tempOrderStatus = "";
    }
    summaryInfo({
      fromDate: this.fromDate && this.fromDate.toString().split(",")[0],
      toDate: this.fromDate && this.fromDate.toString().split(",")[1],
      nickname: this.nickname,
      phone: this.phone,
      receiverName: this.receiverName,
      receiverPhone: this.receiverPhone,
      orderId: this.orderId,
      productName: this.productName,
      payType: this.payType,
      orderStatus: tempOrderStatus,
      shippingMethod: this.shippingMethod,
      operationMemberId: this.operationMemberId,
      serviceId: this.operationServiceId,
      subCompanyId: this.operationSubCompanyId
    }).then((res: any) => {
      let summary = res.data;
      this.$emit("setSummary", summary);
    });
  }

  // 导出excel
  importExcel() {
    this.showLoading();
    let tempOrderStatus = <any>this.orderStatus;
    if (tempOrderStatus == 20) {
      tempOrderStatus = "";
    }
    axios({
      // 指定请求方式
      method: "get",
      url: config.baseUrl + "/oms/order/excel/exportOrderListInfo",
      // 请求类型为blob
      responseType: "blob",
      withCredentials: true, // 允许附带cookit
      headers: {
        Authorization: this.$store.getters.token, // 附带的token
      },
      params: {
        fromDate: this.fromDate && this.fromDate.toString().split(",")[0],
        toDate: this.fromDate && this.fromDate.toString().split(",")[1],
        nickname: this.nickname,
        phone: this.phone,
        receiverName: this.receiverName,
        receiverPhone: this.receiverPhone,
        orderId: this.orderId,
        productName: this.productName,
        payType: this.payType,
        orderStatus: tempOrderStatus,
        shippingMethod: this.shippingMethod,
      },
    })
      .then((res) => {
        let blob = new Blob([res.data], { type: "application/vnd.ms-excel" }); // res就是接口返回的文件流了
        let objectUrl = URL.createObjectURL(blob);
        let a = document.createElement("a");
        let time = filterTime(Date.now());
        console.log(time);
        a.setAttribute("href", objectUrl);
        a.setAttribute("download", `养博城后台订单表单${time}.xls`);
        a.click();
        this.hideLoading();
      })
      .catch((err) => {
        this.hideLoading();
        this.$message.error(err);
      });
  }
}
